import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Show } from '@atlaskit/primitives/responsive';
import Toggle from '@atlaskit/toggle';
import { RequestReadState } from '@atlassian/notification-types/types';
import { messages } from '../../../index';
import { ToggleText } from './styled';
var ToggleReadState = function ToggleReadState(_ref) {
  var readStateFilter = _ref.readStateFilter,
    toggleReadStateFilter = _ref.toggleReadStateFilter;
  if (fg('jira_improve_notifications_on_mobile')) {
    return /*#__PURE__*/React.createElement(Show, {
      above: "xs"
    }, /*#__PURE__*/React.createElement(ToggleText, {
      htmlFor: 'mark-as-read-toggle'
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.onlyShowUnread)), /*#__PURE__*/React.createElement(Toggle, {
      id: "mark-as-read-toggle",
      testId: "read-state-toggle",
      onChange: toggleReadStateFilter,
      isChecked: readStateFilter === RequestReadState.UNREAD
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleText, {
    htmlFor: 'mark-as-read-toggle'
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.onlyShowUnread)), /*#__PURE__*/React.createElement(Toggle, {
    id: "mark-as-read-toggle",
    testId: "read-state-toggle",
    onChange: toggleReadStateFilter,
    isChecked: readStateFilter === RequestReadState.UNREAD
  }));
};
export default ToggleReadState;